import React from 'react';
import { TabsContextProvider } from './TabsContext';

export const TabsContainer = ({ className, children, initial }) => (
    <TabsContextProvider className={className} initial={initial}>
        {children}
    </TabsContextProvider>
);
